var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"13.627","cy":"30.7584","r":"6.23787","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M13.627 36.9961L13.627 50.1761","stroke":"currentColor","strokeLinecap":"round","key":1}),React.createElement("circle",{"cx":"50.3731","cy":"30.7584","r":"6.23787","stroke":"currentColor","strokeWidth":"2","key":2}),React.createElement("path",{"d":"M50.373 36.9961L50.373 50.1761","stroke":"currentColor","strokeLinecap":"round","key":3}),React.createElement("circle",{"cx":"31.9997","cy":"18.1955","r":"8.48262","stroke":"currentColor","strokeWidth":"2","key":4}),React.createElement("path",{"d":"M32 28.0859L32 53.324","stroke":"currentColor","strokeLinecap":"round","key":5})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 64 65"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
